import { TWEEN } from 'three/examples/jsm/libs/tween.module.min';
import { EaseBase, EaseEnd } from './J3TypeList';

export class J3TweenHelper {
    easeType = TWEEN.Easing.Linear.None;

    constructor (public duration = 1000){
    }

    SetTweenParam(duration=1000, easeBase:EaseBase = 'Quartic', easeEnd:EaseEnd = 'InOut'){
        this.duration = duration;
        this.easeType = this.GetEaseType(easeBase, easeEnd);
    }

    GetEaseType(base:EaseBase = 'Quartic', end:EaseEnd = 'InOut'){

        let easeType;
        if (base == 'Linear'){
            easeType = TWEEN.Easing.Linear.None;
        }else if (base == 'Quadratic') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Quadratic.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Quadratic.Out;
            } else {
                easeType = TWEEN.Easing.Quadratic.InOut;
            }
        } else if (base == 'Cubic') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Cubic.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Cubic.Out;
            } else {
                easeType = TWEEN.Easing.Cubic.InOut;
            }
        } else if (base == 'Quartic') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Quartic.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Quartic.Out;
            } else {
                easeType = TWEEN.Easing.Quartic.InOut;
            }
        } else if (base == 'Quintic') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Quintic.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Quintic.Out;
            } else {
                easeType = TWEEN.Easing.Quintic.InOut;
            }
        } else if (base == 'Sinusoidal') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Sinusoidal.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Sinusoidal.Out;
            } else {
                easeType = TWEEN.Easing.Sinusoidal.InOut;
            }
        } else if (base == 'Exponential') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Exponential.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Exponential.Out;
            } else {
                easeType = TWEEN.Easing.Exponential.InOut;
            }
        } else if (base == 'Circular') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Circular.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Circular.Out;
            } else {
                easeType = TWEEN.Easing.Circular.InOut;
            }
        } else if (base == 'Elastic') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Elastic.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Elastic.Out;
            } else {
                easeType = TWEEN.Easing.Elastic.InOut;
            }
        } else if (base == 'Back') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Back.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Back.Out;
            } else {
                easeType = TWEEN.Easing.Back.InOut;
            }
        } else if (base == 'Bounce') {
            if (end == 'In') {
                easeType = TWEEN.Easing.Bounce.In;
            } else if (end == 'Out') {
                easeType = TWEEN.Easing.Bounce.Out;
            } else {
                easeType = TWEEN.Easing.Bounce.InOut;
            }
        } else {
            easeType = TWEEN.Easing.Linear.None;
        }
        return easeType;
    }
}